<template>
  <div>
    <sidebar-right-side :uploadEndpoint="uploadEndpoint" :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar" :data="sidebarData" :fieldStructure="dataStructure" :key="operation + formType"
      :endPoint="endPoint" :addionalData="filter" @addNew="(value) => addNew(value)" />
    <search v-if="dataStatructureReady" :totalData="totalData" @submit="(data) => filterHandler(data)" />

    <vs-popup fullscreen title="PDF Preview" :active.sync="pdfPreview">
      <vue-pdf :key="updateUrl" :sourceFile="updateUrl" />
    </vs-popup>
    <vs-popup fullscreen title="Attachment Preview" :active.sync="showImage">
      <div class="centerx">
        <img :src="updateImageUrl" :sourceFile="updateImageUrl" />
      </div>
    </vs-popup>

    <vs-popup fullscreen title="Info" :active.sync="showPopupInfo">
      <show-info @result="(val) => handleResult(val)" :key="curentRowId" />
    </vs-popup>

    <vs-popup fullscreen title="Documents" :active.sync="showPdf">
      <vs-row class="p-2">
        <vs-col class="p-2" vs-type="flex" vs-w="12">
          <h2>
            <span class="text-primary bold" style="font-weight: bold;">EQUIPMENT NUMBER</span>
            : {{ documentSelected.equipmentTag }}
          </h2>
        </vs-col>
        <vs-col class="p-2" vs-type="flex" vs-w="12">
          <h2>
            <span class="text-primary bold" style="font-weight: bold;">JOINT
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            : {{ documentSelected.joint }}
          </h2>
        </vs-col>
      </vs-row>
      <vs-row v-show="showDocuments">
        <vs-col v-for="(fName, indexTd) in documents" :key="indexTd" vs-type="flex" vs-justify="center" vs-align="center"
          vs-w="2" class="p-5">
          <vx-card>
            <div slot="no-body" class="center" style="text-align: center; height: 250px; overflow: auto;">
              <img v-if="fName.extension == 'pdf'" src="@/assets/images/logo/pdf.png" alt="content-img"
                class="responsive card-img-top" />
              <img v-else :src="baseURl + '/storage/' + fName.documentPath" alt="content-img"
                class="responsive card-img-top" height="100px" width="auto" />
            </div>
            <h5 class="mb-2 center" style="height: 50px; overflow: auto;">
              {{ fName.fileName }}
            </h5>
            <div class="flex justify-center flex-wrap pt-5" v-if="getUserInfo.role != 'admin'">
              <vs-icon v-if="getUserInfo.role != 'admin'" style="cursor: pointer;"
                @click.stop="showPdfOrImage(fName.documentPath)" icon="airplay" size="medium" color="success"></vs-icon>
            </div>
            <div class="flex justify-between flex-wrap pt-5" v-if="getUserInfo.role == 'admin'">
              <vs-icon v-if="getUserInfo.role == 'admin'" style="cursor: pointer;" @click="
                downloadFile(baseURl + '/storage/' + fName.documentPath)
                " icon="file_download" size="medium" color="primary"></vs-icon>
              <vs-icon v-if="getUserInfo.role == 'admin'" style="cursor: pointer;"
                @click.stop="showPdfOrImage(fName.documentPath)" icon="airplay" size="medium" color="success"></vs-icon>
              <vs-icon v-if="getUserInfo.role == 'admin'" style="cursor: pointer;" @click="removeFileFromRecord(fName.id)"
                icon="delete" size="medium" color="danger"></vs-icon>
            </div>
          </vx-card>
        </vs-col>

        <vs-col slot="" vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" class="p-10"
          v-if="getUserInfo.role == 'admin'">
          <vx-card>
            <div slot="no-body">
              <aron-file @refresh="(val) => getDocument(false)" :baseURl="baseURl" uploadEndpoint="uploadJointDocs"
                index="test" value="" validation="" :jointId="jointId"></aron-file>
            </div>
          </vx-card>
        </vs-col>
      </vs-row>

      <!-- <vue-pdf :key="updateUrl" :sourceFile="updateUrl" /> -->
    </vs-popup>

    <vs-prompt cancelText="No" acceptText="Yes" title="Confirm Remove" @cancel="showAlertRemove = false"
      @accept="removeFileFromRecord" :active.sync="showAlertRemove">
      <span>Are you sure you want to remove this attachment?</span>
    </vs-prompt>
    <vs-table dense v-show="!showPopupInfo" id="loader" class="vs-con-loading__container" :sst="true" @sort="handleSort"
      v-model="selected" @selected="handleSelected" max-items="3" :data="tableComputedData" stripe>
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center" v-if="showAdd">
          <!-- ADD NEW -->
          <div v-if="showAddBtn"
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 pull-right" style="text-align: right;">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * per_page - (per_page - 1) }} -
              {{
                pageTotal - currentPage * per_page > 0
                ? currentPage * per_page
                : pageTotal
              }}
              of {{ totalData }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="per_page = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page = 30">
              <span>30</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page = 50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page = 100">
              <span>100</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page = 300">
              <span>300</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="per_page = 500">
              <span>500</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <template v-for="(fName, indexTd) in dataStructure">
          <vs-th style="
              border-bottom: solid;
              border-width: thin;
              border-color: gray;
            " class="text-md" v-if="handleProjectSelected(fName)" :sort-key="indexTd" :key="indexTd">
            {{ fName.label == 'WORKLIST' ? 'Scope No' : fName.label
            }}</vs-th>
        </template>
      </template>

      <template slot-scope="{ data }">
        <vs-tr style="
            border-bottom: solid;
            border-width: thin;
            border-color: #dcdcdc;
          " :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <template v-for="(fName, indexTd) in dataStructure">
            <template v-if="handleProjectSelected(fName)">
              <vs-td :class="decodeSelectValue(indextr, indexTd, fName.data)" class="text-md"
                v-if="fName.type == 'aronSelect'" :data="data[indextr][indexTd]" :key="indexTd">{{
                  decodeSelectValue(indextr, indexTd, fName.data) }}
              </vs-td>

              <vs-td class="text-md" v-else-if="fName.type == 'aronMultiSelect'" :data="data[indextr][indexTd]"
                :key="indexTd">{{ decodeMultiSelectValue(indextr, indexTd) }}</vs-td>

              <vs-td class="text-md" v-else-if="fName.type == 'aronFile'" :data="data[indextr][indexTd]" :key="indexTd">
                <div class="text-md" @click.stop="
                  showFileOrImageHandler(
                    data[indextr][indexTd],
                    data[indextr],
                    indextr
                  )
                  ">
                  <span v-if="data[indextr][indexTd] == 'yes'">
                    <feather-icon icon="FileTextIcon"
                      svgClasses="w-10 h-10 hover:text-primary text-primary stroke-current" />
                  </span>
                  <span v-else>
                    <feather-icon icon="FileIcon" svgClasses="w-10 h-10 hover:text-primary  stroke-current" />
                  </span>
                </div>
              </vs-td>




              <vs-td class="text-md" v-else-if="indexTd == 'uploadFake'" :data="data[indextr][indexTd]" :key="indexTd">{{
                data[indextr][indexTd] }} </vs-td>


              <vs-td class="text-md" v-else :data="data[indextr][indexTd]" :key="indexTd">{{ data[indextr][indexTd] }}
              </vs-td>
            </template>
          </template>
        </vs-tr>
      </template>
    </vs-table>

    <div>
      <vs-pagination :total="pageTotal" v-model="currentx" goto></vs-pagination>
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

//form type
import sidebarRightSide from "../../components/aron/dataViews/sidebarRightSide_joints.vue";
import profile from "../../components/aron/dataViews/profile";
// import popup from "../dataViews/displayOptions/popup_fullscreen.vue";
import { mapGetters } from "vuex";
import selectable from "../../components/aron/table/selectable.vue";

import { alertMixin } from "../../mixin/alertMixin";
import { axiosMixin } from "../../mixin/axiosMixin";
import { helperMixin } from "../../mixin/helperMixin";

import vuePdf from "../../components/aron/dataViews/vuepdf";
import search from "../../components/aron/table/search_joints.vue";
import aronFile from "../../components/aron/formElements/uploadDocs.vue";
import nm from "../../components/aron/formElements/testnum.vue";
import showInfo from "./showPopupInfo.vue";
export default {
  mixins: [alertMixin, axiosMixin, helperMixin],

  components: {
    sidebarRightSide,
    profile,
    selectable,
    vuePdf,
    search,
    showInfo,
    aronFile,
    nm,
  },

  props: {
    endPoint: {
      type: String,
    },
    uploadEndpoint: {
      type: String,
    },
    formType: {
      type: String,
    },
    filter: {
      type: Object,
      default() {
        return {};
      },
    },
    filterEndpoint: {
      type: String,
      default: "",
    },
    viewOnly: {
      type: Boolean,
    },
    showAddBtn: {
      type: Boolean,
      default: true,
    },
    showEditBtn: {
      type: Boolean,
      default: true,
    },
    showActionButton: {
      type: Boolean,
      default: true,
    },
    showCancelBtn: {
      type: Boolean,
      default: true,
    },
    editPage: {
      type: String,
      default: "",
    },
    previewPage: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    showPopupInfo: false, //show details popup
    curentRowId: "", //this is use so that we can trigger a reload to show a popup for row info
    numPages: 3, //total number of pages for pdf preview
    thePdfSource: "", //use to display the PDF
    theImageSource: "", //use to display the IMAGES
    showPopup: false, //this is a form type. if true, the popup will show
    showPdf: false, //use for displaying files from table
    pdfPreview: false, //use for displaying files from table
    showImage: false, //use for displaying files from table
    operation: "add",
    dataStructure: {},
    tblData: [],
    selected: [],
    log: [],
    currentx: 1,
    pageTotal: 1,
    per_page: 10,
    sort_by: "id",
    sort_direction: "desc",
    totalData: 0,
    isMounted: false,
    //for sidebar form
    addNewDataSidebar: false,
    sidebarData: {},
    dataStatructureReady: false,
    currentSelectedRow: {},
    removeAttachmentEndPoint: "removeAttachment",
    currentRowIndex: 0,
    showAlertRemove: false,
    fileSource: "",
    documents: {},
    jointId: "",
    showDocuments: false,
    documentSelected: {},
  }),

  computed: {
    ...mapGetters({
      getProfileId: "profile/getProfileId",
      getMainInfo: "profile/getMainInfo",
      getProjectSelected: "auth/getProjectSelected",
      getUserInfo: "auth/getUserInfo",
    }),
    baseURl() {
      return axios.defaults.baseURL;
    },
    currentPage() {
      if (this.isMounted) {
        return this.currentx;
      }
      return 0;
    },
    tableComputedData() {
      return this.tblData;
    },
    showAdd() {
      return !this.viewOnly;
    },
    updateUrl() {
      return this.thePdfSource;
    },
    updateImageUrl() {
      return this.theImageSource;
    },
  },

  watch: {
    currentx: function () {
      this.getData("from current x");
    },
    per_page: function () {
      this.getData("from perpage");
    },
  },

  created() {
    this.dataStatructureReady = false;
  },

  mounted() {
    this.isMounted = true;
    this.getData("created");
  },

  methods: {
    handleProjectSelected(fName) {
      if (this.getProjectSelected.projectType == "1") {
        if (fName.showInTable == "yes") {
          if (
            fName.label == "WORKLIST" ||
            fName.label == "SUB SYSTEM" ||
            fName.label == "Contractor" ||
            fName.label == "Criticality" ||
            fName.label == "Equipment Number"
          ) {
            return false;
          }
          return true;
        }
      } else if (this.getProjectSelected.projectType == "2") {
        if (fName.showInTable == "yes") {
          if (
            fName.label == "WORK ID" ||
            fName.label == "SUB SYSTEM" ||
            fName.label == "Contractor" ||
            fName.label == "Criticality" ||
            fName.label == "Equipment Number" ||
            fName.label == "WORKLIST" ||
            fName.label == "Status"
          ) {
            return false;
          }
          return true;
        }
      } else if (this.getProjectSelected.projectType == "3") {
        if (fName.showInTable == "yes") {
          if (
            fName.label == "WORK ID" ||
            fName.label == "SUB SYSTEM"
          ) {
            return false;
          }
          return true;
        }
      }
      else if (this.getProjectSelected.projectType == "4") {
        if (fName.showInTable == "yes") {
          if (
            fName.label == "SUB SYSTEM" ||
            fName.label == "Joint Type"
          ) {
            return false;
          }
          return true;
        }
      }

      else {
        if (fName.showInTable == "yes") {
          return true;
        }

        return false;
      }
    },
    downloadFile(url) {
      window.open(url, "_blank");
    },
    confirmRemoveFileFromRecord() {
      this.showPdf = false;
      this.showImage = false;
      this.showAlertRemove = true;
      console.log("status; ", this.showAlertRemove);
    },
    removeFileFromRecord(id) {
      this.startLoading();
      this.aronPost("removeAttachment", { id: id }, "", "")
        .then((response) => {
          console.log("responsessss:", response);

          this.getDocument(false);
          this.closeLoading();
        })
        .catch((error) => {
          // this.decodeErrorFromAxios(error);
          this.closeLoading();
        });
    },
    handleResult(result) {
      this.showPopupInfo = false;
      this.getData("approval");
    },
    showPdfOrImage(source) {
      var filename = this.getFileExtention(source);
      if (filename == "pdf") {
        this.pdfPreview = true;
        this.showImage = false;
        this.thePdfSource = this.baseURl + "/storage/" + source;
      } else if (
        filename == "jpeg" ||
        filename == "jpg" ||
        filename == "png" ||
        filename == "gif"
      ) {
        this.showImage = true;
        this.pdfPreview = false;
        this.theImageSource = this.baseURl + "/storage/" + source;
      }
    },
    showFileOrImageHandler(source, row, indextr) {
      console.log("row:", row.id);
      this.jointId = row.id;
      this.documentSelected = row;
      this.getDocument(true);
    },
    getDocument(showPdf) {
      this.startLoading();
      this.showDocuments = false;
      var params = "page=" + this.currentx + "&per_page=" + this.per_page;
      var sort =
        "&sort_by=" + this.sort_by + "&sort_direction=" + this.sort_direction;
      this.aronPost("getDocuments", { id: this.jointId }, params, sort)
        .then((response) => {
          console.log("responsessss:", response.data.docs);
          if (response.status == 200) {
            this.documents = response.data.docs;
            if (showPdf) {
              this.showPdf = true;
            }
            this.showDocuments = true;
          }

          this.getData("docs");

          this.closeLoading();
        })
        .catch((error) => {
          // this.decodeErrorFromAxios(error);
          this.closeLoading();
        });
    },
    returnFilters() {
      return {
        pkId: this.getMainInfo.prVendorId,
      };
    },
    startLoading() {
      this.$vs.loading({
        container: "#loader",
        scale: 0.6,
      });
    },
    closeLoading() {
      this.$vs.loading.close("#loader > .con-vs-loading");
    },
    decodeSelectValue(tr, td, options) {
      return this.decodeValueForSelect(options, this.tblData[tr][td]);
    },
    // decodeSelectValue(value,options) {
    //  return this.arrayOfObjectFind(options,value)[0].label;
    // },
    decodeMultiSelectValue(tr, td) {
      return this.flattenJsonStringArray(this.tblData[tr][td], "label");
    },

    addNew($val) {
      if (this.sort_direction == "asc") {
        var newTotalPage = Math.ceil((this.totalData + 1) / this.per_page);
        if (this.currentx != newTotalPage) {
          this.currentx = newTotalPage;
        } else {
          this.getData("add new");
        }
      } else {
        if (this.currentx == this.pageTotal) {
          this.getData("add new");
        } else {
          this.currentx = this.pageTotal;
        }
      }
    },
    filterHandler(data) {
      this.filterData = data;
      this.addToObject(this.filterData, {
        pkId: this.getProjectSelected["id"],
      });
      this.addToObject(this.filter, {
        advanceFilter: this.filterData,
      });
      this.getData("advance filter");
    },

    deleteData(data) {
      this.aronDelete(this.endPoint, data.id, "Item Deleted!")
        .then((response) => {
          if (this.countObject(this.tblData) <= 0) {
            this.currentx = this.currentx - 1;
            if (this.currentx < 0) {
              this.currentx = 0;
            }
          } else {
            this.getData("delete");
          }
        })
        .catch((error) => {
          console.error("in elete error: ", error);
        });
    },
    handleSort(key, direction) {
      this.sort_by = key;
      this.sort_direction = direction;
      this.getData("from sort");
    },
    handleClick(type, index) {
      //console.log(this.tblData[index]);
    },
    insertDone(val) {
      this.showPopup = false;
      this.getData("insert");
    },
    handleSelected(tr) {
      this.curentRowId = tr.id;
      console.log("trrr:", tr);
      this.$store.dispatch("profile/setCurrentMainInfo", tr);
      this.$store.dispatch(
        "profile/setCurrentMainDataStructure",
        this.dataStructure
      );
      this.showPopupInfo = true;
    },
    getData(from) {
      this.startLoading();
      var params = "page=" + this.currentx + "&per_page=" + this.per_page;
      var sort =
        "&sort_by=" + this.sort_by + "&sort_direction=" + this.sort_direction;
      console.log("this.filterEndpoint::", this.filterEndpoint);
      console.log("this.filter::", this.filter);

      if (this.countObject(this.filter) > 0) {
        this.aronPost(this.filterEndpoint, this.filter, params, sort)
          .then((response) => {
            console.log("responsessss:", response);
            if (response.status == 200) {
              if (response.data.data != null) {
                this.tblData = response.data.data;
              } else {
                this.tblData = [];
              }

              this.dataStructure = response.data.fields;

              this.setDataStructure();
              this.dataStatructureReady = true;

              this.totalData = response.data.meta.pagination.total;
              this.pageTotal = response.data.meta.pagination.total_pages;
            }

            this.closeLoading();
          })
          .catch((error) => {
            // this.decodeErrorFromAxios(error);
            this.closeLoading();
          });
      } else {
        this.aronGet(this.endPoint, params, sort)
          .then((response) => {
            this.tblData = response.data.data;
            this.dataStructure = response.data.fields;

            this.setDataStructure();
            this.dataStatructureReady = true;

            this.pageTotal = response.data.meta.pagination.total_pages;
            this.totalData = response.data.meta.pagination.total;

            this.closeLoading();
          })
          .catch((error) => {
            // this.decodeErrorFromAxios(error);
            this.closeLoading();
          });
      }
    },
    setDataStructure() {
      this.$store.dispatch("profile/setMainDataStructure", this.dataStructure);
    },
    editData(data) {
      //change the operation to update
      this.operation = "update";
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    addNewData() {
      if (this.formType == "sidebarRightSide") {
        this.sidebarData = {};
        this.toggleDataSidebar(true);
      } else if (this.formType == "profile") {
        this.$store.dispatch("profile/setMainInfo", {});
        this.$store.dispatch(
          "profile/setMainDataStructure",
          this.dataStructure
        );

        this.$router
          .push("/edit/" + this.endPoint + "/" + "new")
          .catch(() => { });
      } else if (this.formType == "popup") {
        this.showPopup = true;
      } else {
        this.$store.dispatch("profile/setMainInfo", {});
        this.$store.dispatch(
          "profile/setMainDataStructure",
          this.dataStructure
        );

        this.$router
          .push("/" + this.editPage + "/" + this.endPoint)
          .catch(() => { });
      }
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
  },
};
</script>

<style>
.Complete {
  background-color: #28C76F;
  color: white;
  font-weight: bold
}

.Box-Up {
  background-color: yellow;
  color: black;
  font-weight: bold
}

.Defect {
  background-color: #EA5455;
  color: black;
  font-weight: bold
}

.Break {
  background-color: #7367F0;
  color: black;
  font-weight: bold
}

. {
  background-color: #7367F0;
  color: black;
  font-weight: bold
}
</style>